import { render } from "./PaymentHistory.vue?vue&type=template&id=134369cc&scoped=true&ts=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts"

import "./PaymentHistory.vue?vue&type=style&index=0&id=134369cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134369cc"]])

export default __exports__